import { defineComponent as _defineComponent } from 'vue'
import { isValidRecord } from '@/composables/generics';
import CreationWizard from '@/components/CreationWizard/CreationWizard.vue';
import { CreationProcess } from '@/components/CreationWizard/types';

import { EmbeddedAppActionTypes, useEmbeddedApp } from '@/views/SideBar/embedded-app-entry-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmbeddedCreationWizard',
  props: {
    featureTypeId: null,
    appId: null,
    slug: null,
    serviceWorkspaceId: null,
    currentUrl: null,
    toolPlacement: null,
    elementType: null
  },
  setup(__props: any) {

const props = __props as {
	featureTypeId: string;
	appId?: number;
	slug: string;
	serviceWorkspaceId?: string | number;
	currentUrl: string;
	toolPlacement?: string;
	elementType?: string;
}


const { sendMessage } = useEmbeddedApp();
const close = () => {
	sendMessage({ action: EmbeddedAppActionTypes.Close });
};
const startCreationProcess = (creationProcess: CreationProcess) => {
	console.log('creationProcess', creationProcess);
	if (!isValidRecord(creationProcess)) {
		throw new Error('Invalid creation process');
	}
	sendMessage({ action: EmbeddedAppActionTypes.StartCreationProcess, payload: creationProcess });
};

return { __sfc: true,props, sendMessage, close, startCreationProcess, CreationWizard }
}

})